import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

// Components
import Loader from "../components/common/Loader";
import Menu from "../components/home1/Menu";
import Navbar from "../components/home1/Navbar";
import Header from "../components/home1/Header";
import Experience from "../components/home1/Experience";
import Services from "../components/home1/Services";
import Process from "../components/home1/Process";
import ProjectsShowcase from "../components/home1/ProjectsShowcase";
import Awards from "../components/home1/Awards";
import Footer2 from "../components/home2/Footer";

function Home1() {
  const { t } = useTranslation("homepage");

  return (
    <>
      <Helmet>
        {/* CSS Styles */}
        <link
          rel="stylesheet"
          href="/home1/assets/css/home_1_style.css"
        />
        <link
          rel="stylesheet"
          href="/home5_residence/assets/css/home_5_style.css"
        />
        <link
          rel="stylesheet"
          href="/home2/assets/css/home_2_style.css"
        />
        <link rel="stylesheet" href="/home10/assets/css/home_10_style.css" />

        {/* JS Scripts */}
        <script src="/common/assets/js/common_js.js" defer></script>
        <script src="/home1/assets/js/home_1_scripts.js" defer></script>
        <script src="/home5_residence/assets/js/home_5_scripts.js" defer></script>
        <script src="/home10/assets/js/home_10_scripts.js"></script>
         <meta
          name="description"
          content={t("meta.description")}
        />
      </Helmet>
{/*Irina */}
      <div className="home-style1">
        <Loader />
        <Menu />
        <div className="smooth-scroll-content" id="scrollsmoother-container">
          <Navbar />
          <Header />
          <main>
            <Experience />
            <ProjectsShowcase />
            <Awards />
            <Process />
            <Services />
          </main>
          <Footer2 />
        </div>
      </div>
    </>
  );
}

export default Home1;
